<template>
  <div class="topConcertInfo textShadow">
    <div class="info__artistName">
      {{ info.artist_name }}
    </div>
    <div class="info__concertName">
      {{ info.name }}
    </div>
  </div>
</template>

<script>
export default {
  name: "TopConcertInfo",
  computed: {
    info() {
      return this.$store.state.concert.info;
    }
  }
};
</script>

<style scoped lang="sass">
@import "../../../sass/common"
.topConcertInfo
    text-align: center
    @include bold
.info__artistName
    @include vw(20)
.info__concertName
    @include vw2(32)
    text-overflow: ellipsis
    overflow: hidden
    white-space: nowrap
    width: 90%
    margin: auto

</style>
